<template>
  <v-layout
    class="searchInput"
    wrap
    grow
  >
    <v-flex
      md6
      grow
      px-1
    >
      <label class="cmr-book-form-label">Customer Name</label>
      <CustomerSearchInput
        :customer="customer"
        :clearable="true"
        :outlined="false"
        prepend-icon="mdi-account-search"
        placeholder="Type customer name"
        v-model="customerName"
        :loading="loading"
        :customer-selected="customerSelectedName"
        :lookup="lookupByName"
        :customer-list="customerListName"
        :input-changed="nameChanged"
        item-text="name"
        @input="customerSelectedName"
        :enabled="true"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import qs from "qs";
import axios from "axios";
import CustomerSearchInput from '@/components/overwatch/filters/CustomerSearchInput'

axios.defaults.withCredentials = true;

export default {
  name: "CustomerSearchFilter",
  components: {
    CustomerSearchInput,
  },
  props: {
    customer: {
      type: String,
      default: null
    }
  },
  model: {
    prop: "content",
    event: "input",
  },
  computer: {},
  data() {
    return {
      menu: false,
      customerId: '',
      customerName: '',
      showBusinessUser: false,
      customerListName: [],
      customerListNumber: [],
      loading: false,
      name: "",
      number: "",
    };
  },
  watch: {
    customer () {
      if (!this.customer) {
        this.customerId = ''
        this.customerName = ''
      }
    }
  },
  methods: {
    nameChanged: function (name) {
      // console.log("Name " + JSON.stringify(name));
    },
    customerSelectedName: function (val) {
      console.log("customer selected " + JSON.stringify(val));
      if (val != null && val.id != null) {
        this.customerId = val.id
        this.customerName = val.name
        this.$emit('customerSelected', this.customerId)
      } else {
        this.$emit('customerSelected', '')
      }
    },
    lookupByName: function (val) {
      if (val == null) return;
      if (val.length <= 1) return;

      this.name = val;

      var url = `${this.$store.state.apiUrl}/customer/findByName?name=${val}`;

      var searchCompleted = this.searchCompletedName;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (val == vm.name) {
            searchCompleted(res.data);
          }
        })
        .catch(function (err) {
          console.error(err);
          this.loading = false;
        });
    },
    searchCompletedName: function (data) {
      this.customerListName = data;

      this.loading = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.small-fab-phone {
  transform: scale(0.7);
  transform-origin: left;
}
</style>
